<template>
	<div class="EditItemMaster">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<div>
			<el-row :gutter="20" class="top-margin">
				<!-- <el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<label>Applicable to all Stores?</label>
					<el-checkbox
						v-model="checked"
						style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
						:border="true"
						size="medium"
						true-label="all"
						false-label="none"
					>
						<p v-if="checked == 'all'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="checked == 'none'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox>
				</el-col> -->
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<p class="input-label">Select Location</p>
					<div>
						<el-select
							v-model="outletSelected"
							class="custom-input"
							style="width: 100%;"
							collapse-tags
							filterable
							placeholder="Select"
							@change="getArticlesForOutlet($event, pageInfo)"
						>
							<el-option
								v-for="(outlet, index) in outlets"
								:key="index"
								:label="outlet.name"
								:value="outlet.id"
							/>
						</el-select>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
					<p class="input-label">Select Application <span style="color: red;">*</span></p>
					<div>
						<el-select
							v-model="applicationSelected"
							class="custom-input"
							style="width: 100%;"
							collapse-tags
							placeholder="Select"
							@change="getArticlesForOutlet(outletSelected, pageInfo)"
						>
							<el-option
								v-for="(obj, index1) in applicationList"
								:key="index1"
								:label="obj.name"
								:value="obj.id"
							/>
						</el-select>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
					&nbsp;
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="12">
					<p class="input-label">Search</p>
					<div class="mt-1">
						<el-input v-model="search_string" placeholder="Search" @change="getSearchArticlesForOutlet(outletSelected, pageInfo)">
							 <i
								slot="suffix"
								class="el-icon-search el-input__icon">
							</i>
						</el-input>
					</div>
				</el-col>
			</el-row>
		</div>
		<div>
			<BaseArticleMasterTable
				v-if="articleMaster.length > 0"
				:article-master="articleMaster"
				:edit-ingredient="true"
				:application-selected="applicationSelected"
				:page-info="pageInfo"
				:delete-article-from-server="deleteArticle"
				:handle-page-info-change="handlePageInfoChange"
				@editArticle="editArticle"
			/>
		</div>
	</div>
</template>

<script>
import { ArticleMasterMixin } from "../../../../../mixins/articleMaster.mixin";
import ArticleMasterService from "../../../../services/articleMasterService";
import { CommonMixin } from "../../../../../mixins/common.mixin";
import { resolve } from "q";
import moment from "moment";

let previousOutletId = "";
export default {
	name: "EditItemMaster",
	mixins: [ArticleMasterMixin, CommonMixin],
	data() {
		return {
			checked: "all",
			outlets: [],
			search_string: "",
			previousSearch_string: "",
			outletSelected: "",
			applicationSelected: "",
			applicationList: [
				{ id: "workforceArticleMaster", name: "Workforce planning" },
				{ id: "articleMaster", name: "Inventory planning" }
			],
			articleMaster: [],
			articleMasterKey: 0,
			id: 0,
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 10
			}
		};
	},
	methods: {
		paginate() {
			return pageInfo => {
				// this.getOutletWithUserDetails({}, pageInfo);
				if (this.search_string != "") {
					this.getSearchArticlesForOutlet(this.outletSelected, pageInfo);
				} else {
					this.getArticlesForOutlet(this.outletSelected, pageInfo);
				}
			};
		},
		async deleteArticle(article, index) {
			try {
				await ArticleMasterService.deleteArticle({
					outletId: this.outletSelected,
					articleCode: article.itemCode
				}).then(response => {
					if (response.status === 200) {
						this.articleMaster.splice(index, 1);
						this.$notify.success({
							title: "Success",
							message: "Article deleted Succesfully"
						});
					}
				});
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: `delete failed`
				});
			}
		},
		async sortArticle(article) {
			console.log("article in editArticle", article);
			const validationResult = await this.$validator
				.validateAll()
				.then(result => resolve(result));

			if (validationResult) {
				// var sortedArticleMaster = await Promise.all(
				// 	articleMaster.map(async article => {
				if (article.addNewDepartment) {
					try {
						article.department = await ArticleMasterService.createDepartment({
							name: article.department
						}).then(response => {
							if (response.status === 201) {
								let data = JSON.parse(response.data);
								return resolve(data);
							}
						});
					} catch (err) {
						console.log("err");

						this.$notify.error({
							title: "Fail",
							message: `department creation failed in row ${article.id}`
						});
					}
				}
				if (article.addNewCategory) {
					try {
						article.category = await ArticleMasterService.createCategory({
							name: article.category,
							department: article.department.id
						}).then(response => {
							if (response.status === 201) {
								let data = JSON.parse(response.data);
								return resolve(data);
							}
						});
					} catch (err) {
						console.log("err");

						this.$notify.error({
							title: "Fail",
							message: `category creation failed in row ${article.id}`
						});
					}
				}
				if (article.addNewSubcategory) {
					try {
						article.subcategory = await ArticleMasterService.createSubCategory({
							name: article.subcategory,
							category: article.category.id
						}).then(response => {
							if (response.status === 201) {
								let data = JSON.parse(response.data);
								return resolve(data);
							}
						});
					} catch (err) {
						console.log("err");

						this.$notify.error({
							title: "Fail",
							message: `subcategory creation failed in row ${article.id}`
						});
					}
				}

				return [
					true,
					{
						code: article.itemCode,
						name: article.itemDescription,
						type: article.itemType,
						article_type: article.article_type,
						department: article.department.id,
						category: article.category.id,
						subcategory: article.subcategory.id,
						base_unit: article.baseUnit,
						remarks: article.productRemarks,
						default_cost: article.currentCost,
						order_unit: article.orderUnit,
						order_unit_conversion: article.containsEachBase,
						primary_shelf_life: article.primaryShelfLife,
						secondary_shelf_life: article.secondaryShelfLife,
						ordering_frequency: article.orderingFrequency,
						lead_time: article.leadTime,
						stock_comes_from: article.stockComesFrom,
						service_level: article.serviceLevel,
						min_stock_level: article.minStockLevel,
						forecast_type: article.forecastType,
						default_price: article.salesPrice,
						rounding_quantity: article.rounding_quantity,
						min_order_quantity: article.min_order_quantity,
						// start_date: moment(article.startDate).format("YYYY-MM-DD"),
						// end_date: moment(article.endDate).format("YYYY-MM-DD"),
						item_for: article.item_for
					}
				];
				// 	})
				// );
				// console.log("sortedArticleMaster", sortedArticleMaster);
				// this.editArticle();
			}
			return [false, {}];
		},

		async editArticle(article) {
			console.log("article in editArticle", article);
			if (this.applicationSelected == "articleMaster") {
				article.item_for = "inventory";
			}
			try {
				var [sortStatus, article] = await this.sortArticle(article);
				console.log(sortStatus, article);
				if (sortStatus) {
					await ArticleMasterService.updateArticle({
						outletId: this.outletSelected,
						article: article,
						articleCode: article.code
					}).then(response => {
						console.log("response in edit article", response);
						if (response.status === 200) {
							this.getArticlesForOutlet(this.outletSelected, this.pageInfo);
							this.$notify.success({
								title: "Success",
								message: "Updated Succesfully"
							});
						}
					});
				}
			} catch (err) {
				console.log(err);
				this.$notify.error({
					title: "Fail",
					message: `edit failed`
				});
			}
		},
		async getArticlesForOutlet(outletId, pageInfo) {
			if (this.applicationSelected) {
				// console.log("pre", previousOutletId, "outletId", outletId);
				if (previousOutletId !== outletId) {
					previousOutletId = outletId;
					this.handleResetPageInfoEvent();
					pageInfo = this.pageInfo;
				}
				// console.log("outlet in getArticlesForOutlet", outletId);
				try {
					this.articleMaster = await ArticleMasterService.getArticlesForOutlet({
						outletId: outletId,
						pageInfo: pageInfo
					}).then(response => {
						let data = JSON.parse(response.data);
						console.log(
							"response in getArticlesForOUtlets",
							JSON.parse(response.data).results
						);
						this.pageInfo.totalCount = data.count;
						let articles = data.results;
						return Promise.all(
							articles.map(async article => {
								if (this.applicationSelected == "articleMaster") {
									return {
										itemCode: article.code,
										itemDescription: article.name,
										itemType: article.type,
										article_type: article.article_type,
										department: {
											id: article.department,
											name: article.department_name
										},
										category: {
											id: article.category,
											name: article.category_name
										},
										subcategory: {
											id: article.subcategory,
											name: article.subcategory_name
										},
										baseUnit: article.base_unit,
										min_order_quantity: article.min_order_quantity,
										rounding_quantity: article.rounding_quantity,
										productRemarks: article.remarks,
										currentCost: article.default_cost,
										orderUnit: article.order_unit,
										containsEachBase: article.order_unit_conversion,
										containsEachBase: article.order_unit_conversion,
										primaryShelfLife: article.primary_shelf_life,
										secondaryShelfLife: article.secondary_shelf_life,
										orderingFrequency: article.ordering_frequency,
										leadTime: article.lead_time,
										stockComesFrom: article.stock_comes_from,
										serviceLevel: article.service_level,
										minStockLevel: article.min_stock_level,
										forecastType: article.forecast_type,
										salesPrice: article.default_price,
										status: article.status,
										productType: "regular",
										startDate: "",
										endDate: "",
										addNewDepartment: false,
										addNewCategory: false,
										disableCategory: false,
										id: (function(self) {
											self.id += 1;
											return self.id;
										})(this),
										categories: await this.getAllCategories({
											departmentId: article.department
										}).then(v => resolve(v)),
										addNewSubcategory: false,
										disableSubcategory: false,
										subcategories: await this.getAllSubcategories({
											categoryId: article.category
										}).then(v => resolve(v)),
										disableForecastTypeOptions: {
											manual: false,
											forecast: false
										},
										disableItemTypeOptions: {
											sku: false,
											"raw material": false,
											serveware: false,
											consumable: false,
											condiments: false,
											cleaning: false,
											"kitchen equipment": false,
											miscellaneous: false,
											"menu item": false
										},
										disableItemCode: true
									};
								} else {
									return {
										itemCode: article.code,
										itemDescription: article.name,
										itemType: article.type,
										department: {
											id: article.department,
											name: article.department_name
										},
										category: {
											id: article.category,
											name: article.category_name
										},
										subcategory: {
											id: article.subcategory,
											name: article.subcategory_name
										},
										salesPrice: article.default_price,
										addNewDepartment: false,
										addNewCategory: false,
										disableCategory: false,
										id: (function(self) {
											self.id += 1;
											return self.id;
										})(this),
										categories: await this.getAllCategories({
											departmentId: article.department
										}).then(v => resolve(v)),
										addNewSubcategory: false,
										disableSubcategory: false,
										subcategories: await this.getAllSubcategories({
											categoryId: article.category
										}).then(v => resolve(v)),
										disableForecastTypeOptions: {
											manual: false,
											forecast: false
										},
										disableItemTypeOptions: {
											sku: false,
											"raw material": false,
											serveware: false,
											consumable: false,
											condiments: false,
											cleaning: false,
											"kitchen equipment": false,
											miscellaneous: false,
											"menu item": false
										},
										disableItemCode: true
									};
								}
							})
						);
					});
					// this.articleMaster.forEach(article => {
					// 	this.id += 1;
					// 	article.id = this.id;
					// });
				} catch (err) {
					console.log(err);
	
					this.$notify.error({
						title: "Fail",
						message: `fetching articles failed`
					});
				}
			}
		},
		async getSearchArticlesForOutlet(outletId, pageInfo) {
			if (this.applicationSelected) {
				// console.log("pre", previousOutletId, "outletId", outletId);
				if (previousOutletId !== outletId) {
					previousOutletId = outletId;
					this.handleResetPageInfoEvent();
					pageInfo = this.pageInfo;
				}
				if (this.previousSearch_string !== this.search_string) {
					this.previousSearch_string = this.search_string;
					this.handleResetPageInfoEvent();
					pageInfo = this.pageInfo;
				}
				console.log("outlet in getArticlesForOutlet", outletId);
				try {
					this.articleMaster = await ArticleMasterService.getSearchArticlesForOutlet({
						outletId: outletId,
						pageInfo: pageInfo,
						search_string: this.search_string
					}).then(response => {
						let data = JSON.parse(response.data);
						console.log(
							"response in getArticlesForOUtlets",
							JSON.parse(response.data).results
						);
						this.pageInfo.totalCount = data.count;
						let articles = data.results;
						return Promise.all(
							articles.map(async article => {
								if (this.applicationSelected == "articleMaster") {
									return {
										itemCode: article.code,
										min_order_quantity: article.min_order_quantity,
										rounding_quantity: article.rounding_quantity,
										itemDescription: article.name,
										itemType: article.type,
										department: {
											id: article.department,
											name: article.department_name
										},
										category: {
											id: article.category,
											name: article.category_name
										},
										subcategory: {
											id: article.subcategory,
											name: article.subcategory_name
										},
										baseUnit: article.base_unit,
										productRemarks: article.remarks,
										currentCost: article.default_cost,
										availability_type: article.availability_type,
										availability_type_start: article.availability_type_start,
										availability_type_end: article.availability_type_end,
										orderUnit: article.order_unit,
										containsEachBase: article.order_unit_conversion,
										primaryShelfLife: article.primary_shelf_life,
										secondaryShelfLife: article.secondary_shelf_life,
										orderingFrequency: article.ordering_frequency,
										leadTime: article.lead_time,
										stockComesFrom: article.stock_comes_from,
										serviceLevel: article.service_level,
										minStockLevel: article.min_stock_level,
										forecastType: article.forecast_type,
										salesPrice: article.default_price,
										status: article.status,
										productType: "regular",
										startDate: "",
										endDate: "",
										addNewDepartment: false,
										addNewCategory: false,
										disableCategory: false,
										id: (function(self) {
											self.id += 1;
											return self.id;
										})(this),
										categories: await this.getAllCategories({
											departmentId: article.department
										}).then(v => resolve(v)),
										addNewSubcategory: false,
										disableSubcategory: false,
										subcategories: await this.getAllSubcategories({
											categoryId: article.category
										}).then(v => resolve(v)),
										disableForecastTypeOptions: {
											manual: false,
											forecast: false
										},
										disableItemTypeOptions: {
											sku: false,
											"raw material": false,
											serveware: false,
											consumable: false,
											condiments: false,
											cleaning: false,
											"kitchen equipment": false,
											miscellaneous: false,
											"menu item": false
										},
										disableItemCode: true
									};
								} else {
									return {
										itemCode: article.code,
										itemDescription: article.name,
										itemType: article.type,
										department: {
											id: article.department,
											name: article.department_name
										},
										category: {
											id: article.category,
											name: article.category_name
										},
										subcategory: {
											id: article.subcategory,
											name: article.subcategory_name
										},
										salesPrice: article.default_price,
										addNewDepartment: false,
										addNewCategory: false,
										disableCategory: false,
										id: (function(self) {
											self.id += 1;
											return self.id;
										})(this),
										categories: await this.getAllCategories({
											departmentId: article.department
										}).then(v => resolve(v)),
										addNewSubcategory: false,
										disableSubcategory: false,
										subcategories: await this.getAllSubcategories({
											categoryId: article.category
										}).then(v => resolve(v)),
										disableForecastTypeOptions: {
											manual: false,
											forecast: false
										},
										disableItemTypeOptions: {
											sku: false,
											"raw material": false,
											serveware: false,
											consumable: false,
											condiments: false,
											cleaning: false,
											"kitchen equipment": false,
											miscellaneous: false,
											"menu item": false
										},
										disableItemCode: true
									};
								}
							})
						);
					});
					// this.articleMaster.forEach(article => {
					// 	this.id += 1;
					// 	article.id = this.id;
					// });
				} catch (err) {
					console.log(err);
	
					this.$notify.error({
						title: "Fail",
						message: `fetching articles failed`
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/variable.scss";

.EditItemMaster {
	margin: 20px 0;
	box-shadow: $app-card-shadow;
	background-color: #fff;
	padding: 1rem;
}

.EditItemMaster .custom-input {
	font-size: $input-font-size;
	// height: 40px;
	margin-bottom: 20px;
	margin-top: 5px;
}
.EditItemMaster label {
	color: $input-lable-color;
	font-size: $input-lable-font-size;
}

.EditItemMaster .top-margin {
	margin-top: $top-margin;
}
</style>
<style>
.el-select-dropdown__item {
	text-transform: capitalize;
}
</style>
